/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GdsRcpt0101Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const gdsRcpt0101ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const gdsRcpt0101FetchGdsRcpt0101Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsRcpt0101FetchGdsRcpt0101Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const gdsRcpt0101AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const gdsRcpt0101RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const gdsRcpt0101SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const gdsRcpt0101PrintGdsRcpt0101Loading = (state, { boolean }) => ({
  ...state,
  printIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GdsRcpt0101Types.GDS_RCPT0101_RESET_TIMESTAMP]: gdsRcpt0101ResetTimestamp,
  [GdsRcpt0101Types.GDS_RCPT0101_FETCH_GDS_RCPT0101_LOADING]: gdsRcpt0101FetchGdsRcpt0101Loading,
  [GdsRcpt0101Types.GDS_RCPT0101_FETCH_GDS_RCPT0101_SUCCESS]: gdsRcpt0101FetchGdsRcpt0101Success,
  [GdsRcpt0101Types.GDS_RCPT0101_ADD_SELECTED_DOCUMENTS]: gdsRcpt0101AddSelectedDocuments,
  [GdsRcpt0101Types.GDS_RCPT0101_REMOVE_SELECTED_DOCUMENTS]: gdsRcpt0101RemoveSelectedDocuments,
  [GdsRcpt0101Types.GDS_RCPT0101_SET_WORKSPACE_VISIBLE]: gdsRcpt0101SetWorkspaceVisible,
  [GdsRcpt0101Types.GDS_RCPT0101_PRINT_GDS_RCPT0101_LOADING]: gdsRcpt0101PrintGdsRcpt0101Loading
});
